module.exports = __webpack_public_path__ + "static/media/ayalon-logo.8bfb4a52.png";